import { render, staticRenderFns } from "./RegistroArma.vue?vue&type=template&id=4c13f48c"
import script from "./RegistroArma.vue?vue&type=script&lang=js"
export * from "./RegistroArma.vue?vue&type=script&lang=js"
import style0 from "./RegistroArma.vue?vue&type=style&index=0&id=4c13f48c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports